import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { URL } from '../../../constant';
import AiBarosem from './aiBarosem/AiBarosem';
import Mathematics from './mathematics/Mathematics';

function ProgressLearningGM() {
  return (
    <Switch>
      <Redirect exact from={URL.PROGRESS_LEARNING.I} to={URL.PROGRESS_LEARNING.AI_BAROSEM} />
      <Route path={URL.PROGRESS_LEARNING.AI_BAROSEM}>
        <AiBarosem />
      </Route>
      <Route path={URL.PROGRESS_LEARNING.MATHEMATICS}>
        <Mathematics />
      </Route>
    </Switch>
  );
}

export default ProgressLearningGM;
